<template>
	<!--TODO: Needs to refactored... -->
	<div v-if="!settings?.hide_report">
		<slot :lock-active="lockActive" name="reportButton">
			<v-btn
				stacked
				data-tour="reportButton"
				@click="openReport"
				:disabled="
					lockActive ||
					!settings?.enable_notifications ||
					typeof lia !== 'undefined'
				"
			>
				<LockBadge
					:visible="lockActive"
					:tip="
						!settings?.enable_notifications
							? 'component.reports.disabledNotifications'
							: !lockActive
								? 'component.reports.createReport'
								: undefined
					"
					un-bordered
					tip-always-on
				>
					<v-icon icon="fa-solid fa-ticket" color="primary"></v-icon>
				</LockBadge>
			</v-btn>
		</slot>
	</div>
</template>

<script setup lang="ts">
import LockBadge from 'components/templates/Badges/LockBadge.vue'
import { useSettingStore } from '@/stores/modules/setting'
import { useSubscription } from '@/composables/subscription'
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useLiaStore } from '@/stores/system'
import { useRoute } from 'vue-router'
import { useModal } from '@/composables/useModal.ts'

const { checkIfSubscribedTo } = useSubscription()
const { data: settings } = storeToRefs(useSettingStore())

const lockActive = computed(() => {
	return !checkIfSubscribedTo('reports').allowed
})
const { person: lia } = storeToRefs(useLiaStore())

const route = useRoute()
const { openModal } = useModal()

// Derive the report context from the page we're on so the single toolbar
// button prefills the building/unit/person you're currently viewing.
function currentContext() {
	if (route.params.unitId) {
		return { context: 'unit', id: Number(route.params.unitId) }
	}
	if (route.path.startsWith('/buildings/') && route.params.id) {
		return { context: 'building', id: Number(route.params.id) }
	}
	if (route.path.startsWith('/persons/') && route.params.id) {
		return { context: 'person', id: Number(route.params.id) }
	}
	return {}
}

function openReport() {
	openModal('reportCreate', { ...currentContext(), origin: route.fullPath })
}
</script>

<style scoped></style>
